export default __webpack_public_path__ + "static/media/audio_15_trueno.f59a5b71.mp3";